<template>
        <div
          v-if="a.requiredCardsBlock3.length "
          class="required-block required-block-3 mb-1"
        >
          <div class="d-flex align-items-center justify-content-between flex-wrap mb-1">
            <b-button variant="link" @click="a.checkThemAll(3)">
              
              <h6 class="required-block-title mb-0">
                <feather-icon
                :icon="a.show_attachments_block3 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                size="16"
                class="mr-1"
              />
                مرفقات رسام الاوتوكاد
              </h6>
            </b-button>
            <div class="d-flex align-items-center mt-1 mt-md-0">
              <b-button
                size="sm"
                variant="outline-danger"
                class="ml-1"
                :disabled="a.loadCadTemplatePackage || a.loadCadTemplatePackageLink"
                @click="a.downloadCadTemplatePackage"
              >
                <b-spinner
                  v-if="a.loadCadTemplatePackage"
                  small
                  class="mr-1"
                />
                <span v-else> تحميل templete </span>
              </b-button>

            </div>
          </div>
          <b-collapse v-model="a.show_attachments_block3">

            <team-editor-card type="drawing" />

            <div class="d-flex flex-wrap required-block-cards">
              <attachment-media-card
                v-for="card in a.requiredCardsBlock3"
                :key="`required-${card.key}`"
                :title="card.key"
                :file="card.file"
                :upload-value="a.requiredUploads[card.key]"
                upload-layout="inline"
                  :show-team-disabled-message="a.isUploadDisabledByTeam(card.key)"
                  :accept="a.getAcceptExtensions(card.key)"
                :upload-disabled="a.isUploadDisabledByTeam(card.key)"
                :uploading="a.isUploadingRequired(card.key)"
                :is-cad-ark="card.key === 'ملف CAD من الارك'"
                card-margin-class="mb-2"
                notes-section-class="mt-2"
                notes-textarea-class="mb-1"
                :show-collection-checkbox="a.isProject168 && Boolean(card.file)"
                :collection-selected="Boolean(card.file && a.isCollectionSelected(card.file))"
                :editing-note="a.isFileNoteEditing(card.file)"
                :note-draft="a.getFileNoteDraft(card.file)"
                :saving-note="a.isFileNoteSaving(card.file)"
                @update:upload-value="a.setRequiredUpload(card.key, $event)"
                @submit-upload="a.submitRequired(card.key)"
                @delete="a.deleteFile(card.file.id)"
                @save-note="a.saveNote(card.file)"
                @cancel-edit-note="a.cancelEditingNote(card.file.id)"
                @start-edit-note="a.startEditingNote(card.file)"
                @update:note-draft="a.setFileNoteDraft(card.file, $event)"
                @collection-change="a.onCollectionCheckboxChange(card.file, $event)"
              />

            </div>
          </b-collapse>

        </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'

export default {
  name: 'AttachmentsBlock3',
  mixins: [attachmentsBlockMixin],
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
